import { VideoData } from 'types/Video/VideoData';

export function getAmpTagForVideoType(type: VideoData['type']) {
  switch (type) {
    case 'raw':
      return 'amp-video';
    case 'youtube':
      return 'amp-youtube';
    case 'vimeo':
      return 'amp-vimeo';
  }
}
